import { lazy, Suspense } from "react";
import CreateEditNewsAlertModal from "./CreateEditNewsAlertModal";
import CreateEditNewsAlertSectionModal from "./CreateEditNewsAlertSectionModal";
import DeleteNewsAlertModal from "./DeleteNewsAlertModal";
import DeleteScheduledBriefingModal from "./DeleteScheduledBriefingModal";

const CreateAndEditScheduledBriefingModal = lazy(
  () =>
    import("./scheduled-briefing-modal/CreateAndEditScheduledBriefingModal"),
);

const NewsAlertModals = () => {
  return (
    <>
      <CreateEditNewsAlertModal />
      <CreateEditNewsAlertSectionModal />
      <DeleteNewsAlertModal />
      <DeleteScheduledBriefingModal />
      <Suspense fallback={null}>
        <CreateAndEditScheduledBriefingModal />
      </Suspense>
    </>
  );
};

export default NewsAlertModals;
